import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import {
  selectors,
  actions,
} from '../../store/dux/field-boundary-management-dux';
import { usePrevious } from '../../hooks';

export function CombineFields({ fields, close }) {
  const dispatch = useDispatch();
  const isWorking = useSelector(selectors.isWorking);
  const wasWorking = usePrevious(isWorking);

  useEffect(() => {
    if (!isWorking && wasWorking) close();
  }, [close, isWorking, wasWorking]);

  return (
    <ConfirmationDialog
      title="Combine Fields?"
      titleIcon={false}
      message={
        <span>
          Are you sure you want to combine the following fields?:{' '}
          {fields.map((f) => f.fieldName).join(', ')}
        </span>
      }
      handleClose={close}
      handleConfirm={confirm}
      confirming={isWorking}
    />
  );

  function confirm() {
    dispatch(actions.combineFields(fields));
  }
}
